import { TaskBuilder } from '../components/TaskBuilder';

export function NewTaskPage() {
  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <h2 className="text-xl font-semibold text-gray-900">Create Task</h2>
      <div className="card p-6">
        <TaskBuilder />
      </div>
    </div>
  );
}
